// extracted by mini-css-extract-plugin
export default {"navbar":"NavBarMenu_navbar__WTsMO","menu":"NavBarMenu_menu__eijdN","link":"NavBarMenu_link__zmcDK"};